/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery', 'pip-model'], function($, pip) {

    var timerIntervalForDeta = null;
    var selectors = {
        timer: '.countDownTimer',
        timer_wrapper: '.countDownTimer-wrapper'
    };

    function getTimeString(timeLeftMins) {
        var hoursLeft = (timeLeftMins / 60 >> 0);
        var minutesLeft = timeLeftMins % 60;
        var timeString = '';
        if (hoursLeft > 0) {
            timeString += ' ' + hoursLeft + (hoursLeft == 1 ? " hr" : " hrs");
        }
        if (minutesLeft > 0) {
            timeString += ' ' + minutesLeft + (minutesLeft == 1 ? " min" : " mins");
        }
        return timeString;
    }

    function startTimer() {
        timerIntervalForDeta = setInterval(function(){
            --pip.fulfillment.shipping.shipToHome.dynamicEta.totalMinutes;
            if (pip.fulfillment.shipping.shipToHome.dynamicEta.totalMinutes > 0) {
                updateTimerMarkup();
            } else {
                removeTimers();
            }
        }, 60000);
    }

    function updateTimerMarkup() {
        $(selectors.timer).each(function() {
            $(selectors.timer).html(getTimeString(pip.fulfillment.shipping.shipToHome.dynamicEta.totalMinutes));
        });
    }

    function removeTimers() {
        clearInterval(timerIntervalForDeta);
        $(selectors.timer_wrapper).remove();
    }

    return {
        initCountDownTimer: function initCountDownTimer() {
            clearInterval(timerIntervalForDeta);

            if (pip.fulfillment.shipping && pip.fulfillment.shipping.shipToHome && pip.fulfillment.shipping.shipToHome.dynamicEta) {
                updateTimerMarkup();
                startTimer();
            }
        },
        getTimeString: getTimeString,
        removeTimers: removeTimers
    }
});

}.call(window));